// @flow

import { SUGGESTION_UPDATE } from "../actions"

export default ( state: any = {}, action: any ) => {
  switch ( action.type ) {
  case SUGGESTION_UPDATE:
    return {
      ...state,
      [ action.name ]: action.response,
    }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/suggestions.jsx